var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeatherPartlyCloudy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 1.5V3.1M3.85 10H2.25M5.7012 4.95137L4.56982 3.82M15.7998 4.95137L16.9312 3.82M19.25 10H17.65M6.75007 10.0001C6.75007 7.79093 8.54093 6.00007 10.7501 6.00007C12.2561 6.00007 13.5677 6.83235 14.2501 8.06206M6.25 22C4.04086 22 2.25 20.2091 2.25 18C2.25 15.7909 4.04086 14 6.25 14C6.71419 14 7.15991 14.0791 7.57442 14.2245C8.29061 12.3396 10.1139 11 12.25 11C14.3861 11 16.2094 12.3396 16.9256 14.2245C17.3401 14.0791 17.7858 14 18.25 14C20.4591 14 22.25 15.7909 22.25 18C22.25 20.2091 20.4591 22 18.25 22C13.6097 22 10.1292 22 6.25 22Z",
    stroke: "#02222B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherPartlyCloudy);
export default __webpack_public_path__ + "static/media/icon_weather_partly_cloudy.fc625a04d2d52c905f3e2113f0248349.svg";
export { ForwardRef as ReactComponent };